<script setup>
import CustomFieldValue from "@/components/customFields/CustomFieldValue.vue";
import {computed, inject} from "vue";
import {fieldFilled} from "@/helpers/string";
import {validateNumericValue} from "@/helpers/functions";
import trackersCompaniesService from "@/services/trackers-companies.service";

const props = defineProps({
    trackerId: {
        type: Number,
        required: true,
    },

    companyId: {
        type: Number,
        default: 0,
    },

    fromPreview: {
        type: Boolean,
        default: false,
    }
});

const emit = defineEmits(["success", "failed", "answerChanged"]);

const questions = inject('questions');
const loadingQuestions = inject('loadingQuestions', false);

const newFilesFields = computed(() => questions.value.filter(field => field.value.files.some(file => file.id === 0)));
const newFilesFieldsCount = computed(() => newFilesFields.value.length);

function answerChanged(index, value) {
    questions.value[index].value = value;
    emit('answerChanged', questions.value[index]);
}

function validateAnswers() {
    for (let i in questions.value) {
        questions.value[i].error = ''

        if (questions.value[i].required && !fieldFilled(questions.value[i].value)) {
            questions.value[i].error = 'This field is mandatory';
        }

        let error = validateNumericValue(questions.value[i].field, questions.value[i].value.text);

        if (error) {
            questions.value[i].error = error;
        }
    }
}

function saveFiles() {
    let processedCount = 0;
    let successCount = 0;

    newFilesFields.value.forEach(field => {
        let formData = new FormData();

        field.value.files.forEach(file => {
            formData.append('file[]', file)
        })

        trackersCompaniesService.saveAnswerFiles(props.trackerId, props.companyId, field.field.id, formData).then(response => {
            processedCount++;

            if (response.data) {
                successCount++;
            } else {
                questions.value.find(item => item.field.id === field.field.id).error = 'File was not uploaded';
            }

            if (processedCount === newFilesFieldsCount.value) {
                if (processedCount === successCount) {
                    emit('success');
                } else {
                    emit('failed');
                    trackersCompaniesService.deleteAnswers(props.trackerId);
                }
            }
        });
    })
}

defineExpose({
    validateAnswers,
    newFilesFieldsCount,
    saveFiles,
});
</script>

<template>
    <div>
        <div v-if="loadingQuestions" class="loading__spinner mt-3">
            <span><b-spinner class="mb-1 mr-2" small></b-spinner>Loading Questions...</span>
        </div>

        <table class="details-table details-table--submit-startup form w-100">
            <tbody>
                <tr v-for="(question, index) in questions" :key="index">
                    <td :class="{'section-text': question.field.type === 'section_text'}">
                        {{question.field.name}} <span v-if="question.required">*</span>
                    </td>

                    <td v-if="['static_text','section_text'].indexOf(question.field.type) < 0">
                        <CustomFieldValue
                            :field="question.field"
                            :init-value="question.value"
                            :instantUpdate="false"
                            @valueChanged="(value) => answerChanged(index, value)"
                        />

                        <span
                            v-if="!fromPreview && question.error.length"
                            class="form__error"
                        >
                            {{question.error}}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped>
</style>
